import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Nav from './components/Nav.vue'
import FireBaseAnalytics from '@/services/FireBaseAnalytics'

Vue.config.productionTip = false
Vue.prototype.$analytics = FireBaseAnalytics.initialize();

const viewApp = new Vue({
  router,
  store,
  components: {
		Nav
  },
  render: h => h(App)
})
viewApp.$mount('#app');
